import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { computed, defineComponent } from "vue";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { ModalStatus } from "@/constants/modal";
import BookingModule from "@/store/modules/booking";
import { deleteUnconfirmedTickets } from "@/utils/vue-helpers/booking";
import { BookingStep } from "@/constants/booking";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "AvailabilityInfo",
  components: {},
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var dialogVisible = dialogVisibleForStatus(ModalStatus.AvailabilityInfo);
    var noAvailabilityInfo = computed(function () {
      var bookingAvailabilityInfo = BookingModule.bookingAvailabilityInfo;
      var noAv = bookingAvailabilityInfo === null || bookingAvailabilityInfo === void 0 ? void 0 : bookingAvailabilityInfo.filter(function (info) {
        return info.bookedQty > info.dbAvailability && !info.sellOnSoldOut;
      });

      if (!noAv || !noAv.length) {
        return [];
      }

      return noAv;
    });
    return {
      dialogVisible: dialogVisible,
      noAvailabilityInfo: noAvailabilityInfo
    };
  },
  mounted: function mounted() {
    if (!this.noAvailabilityInfo || !this.noAvailabilityInfo.length) this.closeModal();
  },
  methods: {
    closeModal: function closeModal() {
      this.dialogVisible = false;
    },
    removeUnavailablePSS: function removeUnavailablePSS() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, _loop;

        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // for each price that is not available remove its pss from the current booking
                _iterator = _createForOfIteratorHelper(_this.noAvailabilityInfo);
                _context2.prev = 1;
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                  var _BookingModule$select;

                  var info, pssListToDelete, pssList, addonsPSSIds, releaseSeats;
                  return regeneratorRuntime.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          info = _step.value;
                          pssListToDelete = info.pssIds; // lets also delete all the related add-ons

                          pssList = ((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.pssList) || [];
                          addonsPSSIds = pssList.filter(function (pss) {
                            return pss.mainTicketUUID && info.pssIds.includes(pss.mainTicketUUID);
                          }).map(function (pss) {
                            return String(pss.uuid);
                          });
                          pssListToDelete.push.apply(pssListToDelete, _toConsumableArray(addonsPSSIds));
                          releaseSeats = true; // We need to release any seats related to their pss

                          _context.next = 8;
                          return deleteUnconfirmedTickets(pssListToDelete, releaseSeats);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop);
                });

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 8;
                  break;
                }

                return _context2.delegateYield(_loop(), "t0", 6);

              case 6:
                _context2.next = 4;
                break;

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t1 = _context2["catch"](1);

                _iterator.e(_context2.t1);

              case 13:
                _context2.prev = 13;

                _iterator.f();

                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, null, [[1, 10, 13, 16]]);
      }))();
    },
    pssRemovalConfirmation: function pssRemovalConfirmation() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _BookingModule$select2, _BookingModule$select3;

        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.removeUnavailablePSS();

              case 2:
                // Go back to order step if there is no poss remaining for the booking
                if (!((_BookingModule$select2 = BookingModule.selectedBooking) !== null && _BookingModule$select2 !== void 0 && _BookingModule$select2.pssList) || !((_BookingModule$select3 = BookingModule.selectedBooking) !== null && _BookingModule$select3 !== void 0 && _BookingModule$select3.pssList.length)) {
                  // Clear bookingAvailabilityInfo object from the state
                  BookingModule.updateAvailabilityInfo([]); // Move back to Order step

                  BookingModule.setBookingStep({
                    bookingUUID: BookingModule.selectedBookingUUID,
                    step: BookingStep.Order
                  });
                }

                _this2.closeModal();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
});